import { rootContainer } from '~/container'
import { SYMBOLS } from './symbols'

export default defineNuxtPlugin((nuxtApp) => {
  if (nuxtApp.$i18n && !rootContainer.isBound('i18n')) {
    rootContainer.bind('i18n').toConstantValue(nuxtApp.$i18n)
  }

  if (nuxtApp.$sentry && !rootContainer.isBound(SYMBOLS.SentryInstance)) {
    rootContainer.bind(SYMBOLS.SentryInstance).toConstantValue(nuxtApp.$sentry)
  }

  if (
    nuxtApp.$sentryReady &&
    !rootContainer.isBound(SYMBOLS.SentryReadyInstance)
  ) {
    rootContainer
      .bind(SYMBOLS.SentryReadyInstance)
      .toConstantValue(nuxtApp.$sentryReady)
  }
})
